import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import SEOHead from './components/SEOHead';
import Home from './pages/Home';
import DownloadPage from './pages/DownloadPage';
import AdminSettings from './pages/AdminSettings';
import MenuAdmin from './pages/MenuAdmin';
import UserBackgroundManager from './pages/UserBackgroundManager';
import PaymentSuccess from './pages/PaymentSuccess';
import PricingPage from './pages/PricingPage';
import DashboardPage from './pages/DashboardPage';
import FeaturesPage from './pages/FeaturesPage';
import UseCasesPage from './pages/UseCasesPage';
import ResourcesPage from './pages/ResourcesPage';
import NewsPage from './pages/NewsPage';
import AdminDashboard from './pages/AdminDashboard';
import DynamicPage from './pages/DynamicPage';
import AdminThemes from './pages/AdminThemes';
import AdminSEO from './pages/AdminSEO';
import SupportPage from './pages/SupportPage';
import OutlookPage from './pages/OutlookPage';
import GmailPage from './pages/GmailPage';
import AdminEmailTemplates from './pages/AdminEmailTemplates';
import AdminSMTP from './pages/AdminSMTP';
import AdminStorage from './pages/AdminStorage';
import MobileAppPage from './pages/MobileAppPage';
import HelpPage from './pages/HelpPage';
import ContactPage from './pages/ContactPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import TicketViewPage from './pages/TicketViewPage';
import AdminBackgrounds from './pages/AdminBackgrounds';
import VerifyEmailPage from './pages/VerifyEmailPage';
import CheckoutPage from './pages/CheckoutPage';
import AdminStripe from './pages/AdminStripe';
import AdminCaptcha from './pages/AdminCaptcha';
import ExtensionsSettings from './pages/ExtensionsSettings';
import ComparatifPage from './pages/ComparatifPage';
import LogicielPage from './pages/LogicielPage';
import PartnersPage from './pages/PartnersPage';
import AdminPartners from './pages/AdminPartners';
import AdminDocumentation from './pages/AdminDocumentation';
import PublicitePage from './pages/PublicitePage';
import P2PSend from './pages/P2PSend';
import P2PReceive from './pages/P2PReceive';
import CookieConsent from './components/CookieConsent';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <SEOHead />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/share/:shareId" element={<DownloadPage />} />
            <Route path="/download/:shareId" element={<DownloadPage />} />
            <Route path="/admin" element={<AdminSettings />} />
            <Route path="/admin/dashboard" element={<AdminDashboard />} />
            <Route path="/admin/menu" element={<MenuAdmin />} />
            <Route path="/admin/background" element={<UserBackgroundManager />} />
            <Route path="/admin/themes" element={<AdminThemes />} />
            <Route path="/admin/seo" element={<AdminSEO />} />
            <Route path="/payment/success" element={<PaymentSuccess />} />
            <Route path="/profile" element={<Navigate to="/dashboard" replace />} />
            <Route path="/pricing" element={<PricingPage />} />
            <Route path="/dashboard" element={<DashboardPage />} />
            <Route path="/features" element={<FeaturesPage />} />
            <Route path="/use-cases" element={<UseCasesPage />} />
            <Route path="/page/use-cases" element={<UseCasesPage />} />
            <Route path="/comparatif" element={<ComparatifPage />} />
            <Route path="/logiciel" element={<LogicielPage />} />
            <Route path="/resources" element={<ResourcesPage />} />
            <Route path="/news" element={<NewsPage />} />
            <Route path="/nouveautes" element={<NewsPage />} />
            <Route path="/support" element={<SupportPage />} />
            <Route path="/help" element={<HelpPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/outlook" element={<OutlookPage />} />
            <Route path="/gmail-extension" element={<GmailPage />} />
            <Route path="/admin/email-templates" element={<AdminEmailTemplates />} />
            <Route path="/admin/smtp" element={<AdminSMTP />} />
            <Route path="/admin/storage" element={<AdminStorage />} />
            <Route path="/admin/backgrounds" element={<AdminBackgrounds />} />
            <Route path="/admin/stripe" element={<AdminStripe />} />
            <Route path="/admin/captcha" element={<AdminCaptcha />} />
            <Route path="/admin/extensions" element={<ExtensionsSettings />} />
            <Route path="/admin/partners" element={<AdminPartners />} />
            <Route path="/admin/documentation" element={<AdminDocumentation />} />
            <Route path="/partenaires" element={<PartnersPage />} />
            <Route path="/p2p" element={<P2PSend />} />
            <Route path="/p2p/:roomId" element={<P2PReceive />} />
            <Route path="/publicite" element={<PublicitePage />} />
            <Route path="/app-mobile" element={<MobileAppPage />} />
            <Route path="/reset-password" element={<ResetPasswordPage />} />
            <Route path="/ticket/:ticketId" element={<TicketViewPage />} />
            <Route path="/verify-email" element={<VerifyEmailPage />} />
            <Route path="/checkout" element={<CheckoutPage />} />
            {/* Dynamic CMS pages - must be last to catch custom slugs */}
            <Route path="/page/:slug" element={<DynamicPage />} />
          </Routes>
          <CookieConsent />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
